import { createSvgComponent } from "../../icon/createSvgComponent";
import Scrap from "@core/icon/assets/scrap.svg";
export default createSvgComponent(Scrap);